var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15H16.875M9.375 10H13.125",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 25C11.938 26.0871 13.5181 26.7797 15.3294 26.8985C16.7565 26.9922 18.2464 26.992 19.6706 26.8985C20.161 26.8664 20.6956 26.7509 21.156 26.5638C21.6682 26.3556 21.9244 26.2515 22.0546 26.2672C22.1847 26.283 22.3736 26.4205 22.7513 26.6954C23.4173 27.18 24.2563 27.5281 25.5006 27.4982C26.1297 27.4831 26.4443 27.4755 26.5852 27.2386C26.726 27.0016 26.5506 26.6736 26.1998 26.0176C25.7133 25.1077 25.405 24.0661 25.8721 23.2315C26.6766 22.0394 27.3599 20.6276 27.4598 19.1028C27.5134 18.2836 27.5134 17.4351 27.4598 16.6158C27.3932 15.5999 27.1466 14.6341 26.7515 13.75",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4313 21.8585C19.8757 21.5658 23.4159 18.0087 23.7072 13.543C23.7643 12.6691 23.7643 11.7641 23.7072 10.8902C23.4159 6.42461 19.8757 2.86751 15.4313 2.57482C13.915 2.47496 12.3319 2.47516 10.8187 2.57482C6.37429 2.86751 2.83406 6.42461 2.54275 10.8902C2.48575 11.7641 2.48575 12.6691 2.54275 13.543C2.64885 15.1695 3.3749 16.6754 4.22965 17.947C4.72595 18.8372 4.39842 19.9483 3.88148 20.9188C3.50875 21.6185 3.32238 21.9684 3.47202 22.2212C3.62166 22.4739 3.9559 22.482 4.62439 22.4981C5.9464 22.53 6.83785 22.1587 7.54547 21.6417C7.9468 21.3485 8.14747 21.2019 8.28578 21.1851C8.42408 21.1682 8.69625 21.2793 9.24051 21.5014C9.72968 21.701 10.2976 21.8241 10.8187 21.8585C12.3319 21.9581 13.915 21.9583 15.4313 21.8585Z",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingActive);
export default __webpack_public_path__ + "static/media/meetingActive.6ee3796a596af413ab9c1f582c563350.svg";
export { ForwardRef as ReactComponent };